module.exports = __webpack_public_path__ + "static/media/elegant-3.c05fae50.png";